export const NotificationBellRead = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill="url(#paint0_linear_18338_6461)"
        fillOpacity="0.16"
      />
      <path
        d="M23.4961 22H8.49609V20.5H9.24609V15.2736C9.24609 11.5326 12.2682 8.5 15.9961 8.5C19.724 8.5 22.7461 11.5326 22.7461 15.2736V20.5H23.4961V22ZM10.7461 20.5H21.2461V15.2736C21.2461 12.361 18.8956 10 15.9961 10C13.0966 10 10.7461 12.361 10.7461 15.2736V20.5ZM14.1211 22.75H17.8711C17.8711 23.7855 17.0316 24.625 15.9961 24.625C14.9606 24.625 14.1211 23.7855 14.1211 22.75Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18338_6461"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};
